import React, { useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Type1 } from "../Component/QuestionTypeAnswer/Type1";
import VideoQuestion from "../Component/QuestionType_review/VideoQuestion";
import AudioQuestion from "../Component/QuestionType_review/AudioQuestion";
import { GetFunction, SubmitResponse } from "../utils/ApiFunctions";
import { useEffect } from "react";
import { toast } from "react-toastify";
import SubjectiveQuestion from "../Component/QuestionTypeAnswer/SubjectiveQuestion";
import MultipleQuestion from "../Component/QuestionTypeAnswer/MulipleSelectQuestion";
import { useLocalization } from "../Component/Localization/Localization";

function Questions() {
  const { id, assignment } = useParams();
  const navigate = useNavigate();

  const { t } = useLocalization();

  const [questions, setQuestions] = useState([]);
  const [previousQuesitions, setPreviousQuestion] = useState([]);
  const [questionsforparent, setQuestionForParent] = useState([]);
  const [initialValues1, setIntinalValues1] = useState({
    type: "",
    subtype: "",
    marks: "",
    title: "",
    mediaFile: "",
    description: "",
    answer: "",
    questionNo: "",
    answerOption: "",
    options: ["", "", "", ""],
    mulipleansweroption: [],
  });
  async function GetDetails() {
    const res = await GetFunction(`assignments/get_assign_assignment/${id}`);
    if (res.status == 200) {
      setQuestions(res?.data?.data?.questions);
      setQuestionForParent(res?.data?.data?.questions);
    }
  }

  useEffect(() => {
    if (questions && questions.length > 0) {
      const firstQuestion = questions?.[0];

      const optionsObj = [
        ...Object.values(questions?.[0]?.option1),
        ...Object.values(questions?.[0]?.option2),
        ...Object.values(questions?.[0]?.option3),
        ...Object.values(questions?.[0].option4),
        ...Object.values(questions?.[0].option5),
        ...Object.values(questions?.[0].option6),
      ];

      setIntinalValues1({
        type: firstQuestion?.type,
        subtype: firstQuestion?.subtype,
        marks: firstQuestion?.marks,
        title: firstQuestion?.title,
        mediaFile: "",
        questionNo: firstQuestion?.questionNo,
        description: firstQuestion?.description,
        answer: firstQuestion?.answer?.text,
        answerOption: firstQuestion?.answer?.option,
        options: optionsObj,
        mulipleansweroption: firstQuestion?.answer?.multiOption,
        id: firstQuestion?._id,
      });

      //   setQuestions((pre) => pre?.splice(0, 1));
    } else {
      setIntinalValues1({
        type: "",
        subtype: "",
        marks: "",
        title: "",
        mediaFile: "",
        questionNo: "",
        description: "",
        answer: "",
        answerOption: "",
        options: ["", "", "", ""],
        mulipleansweroption: [],
      });
    }
  }, [questions]);

  useEffect(() => {
    GetDetails();
  }, []);

  useEffect(() => {
    if (questions && questions.length > 0) {
      const firstQuestion = questions?.[0];

      const optionsObj = [
        ...Object.values(questions?.[0]?.option1),
        ...Object.values(questions?.[0]?.option2),
        ...Object.values(questions?.[0]?.option3),
        ...Object.values(questions?.[0].option4),
        ...Object.values(questions?.[0].option5),
        ...Object.values(questions?.[0].option6),
      ];

      // setIntinalValues1({
      //   type: firstQuestion?.type,
      //   subtype: firstQuestion?.subtype,
      //   marks: firstQuestion?.marks,
      //   title: firstQuestion?.title,
      //   mediaFile: firstQuestion?.mediaFile,
      //   answer: firstQuestion?.answer?.text,
      //   questionNo: firstQuestion?.questionNo,
      //   description: firstQuestion?.description,
      //   answerOption: firstQuestion?.answer?.option,
      //   options: optionsObj,
      //   mulipleansweroption: firstQuestion?.answer?.multiOption,
      //   id: firstQuestion?._id,
      // });
      setIntinalValues1({
        type: firstQuestion?.type,
        subtype: firstQuestion?.subtype,
        marks: firstQuestion?.marks,
        title: firstQuestion?.title,
        mediaFile: firstQuestion?.mediaFile,
        answer: firstQuestion?.userAnswer?.answer?.text,
        questionNo: firstQuestion?.questionNo,
        description: firstQuestion?.description,
        answerOption: firstQuestion?.userAnswer?.answer?.option,
        options: optionsObj,
        mulipleansweroption: firstQuestion?.userAnswer?.answer?.multiOption,
        id: firstQuestion?._id,
      });
    } else {
      setIntinalValues1({
        type: "",
        subtype: "",
        marks: "",
        title: "",
        mediaFile: "",
        questionNo: "",
        description: "",
        answer: "",
        answerOption: "",
        options: ["", "", "", ""],
        mulipleansweroption: [],
      });
    }
  }, [questions]);

  const DeleteIndexQuestion = (data, id, subtype, type) => {
    if (questions?.length == "0") {
      UpdateAnswer(data, id, subtype, type);
      navigate("/Assignment/awarenessCourses");
    } else {
      UpdateAnswer(data, id, subtype, type);
    }
  };

  const UpdateAnswer = async (data, questionId, subtype, type) => {
    // console.log("questions5000", questions, questions?.length);

    const formdata = new FormData();

    if (questions?.length == "1") {
      formdata?.append("isSubmit", true);
    }
    if (subtype == "subjective") {
      formdata.append("answer", data);
    }
    if (subtype == "objective") {
      formdata.append("answerOption", data);
    }

    if (
      subtype == "multipleSelect" &&
      (type == "writtenQuestion" ||
        type == "photoWithQuestion" ||
        type == "multipleChooseMoreThanOneCorrectAnswer" ||
        type == "videoWithQuestion" ||
        type == "match" ||
        type == "voiceOnly" ||
        type == "multipleChooseOnAnswer")
    ) {
      for (let i = 0; i < data?.length; i++) {
        formdata.append(`multiOption[${i}]`, data[i]);
      }
    }

    // if (subtype == "objective" || type == "") {
    //   formdata.append("answerOption", data);
    // }
    formdata.append("assignmentSheet", id);
    formdata.append("assignmentQuestion", questionId);

    const submitData = await SubmitResponse(
      `assignments/evaluate_question`,
      formdata
    );
    if (submitData?.status == 200) {
      if (subtype == "subjective") {
        initialValues1["answer"] = data;
        initialValues1[`mulipleansweroption[]`] = [];
        initialValues1["answerOption"] = "";
      }
      if (subtype == "objective") {
        initialValues1["answerOption"] = data;
        initialValues1["answer"] = "";
        initialValues1[`mulipleansweroption[]`] = [];
      }

      if (
        subtype == "multipleSelect" &&
        (type == "writtenQuestion" ||
          type == "photoWithQuestion" ||
          type == "multipleChooseMoreThanOneCorrectAnswer" ||
          type == "videoWithQuestion" ||
          type == "match" ||
          type == "voiceOnly" ||
          type == "multipleChooseOnAnswer")
      ) {
        for (let i = 0; i < data?.length; i++) {
          initialValues1[`mulipleansweroption[${i}]`] = data[i];
          initialValues1["answer"] = "";
          initialValues1["answerOption"] = "";
        }
      }

      const updatedArray = questions.slice(1);
      if (updatedArray?.length == "0") {
        navigate("/Assignment/awarenessCourses");
      } else {
        setQuestions(updatedArray);
      }

      // if (previousQuesitions?.length > 0) {
      //   setPreviousQuestion((pre) => [...pre, initialValues1]);
      // } else {
      //   setPreviousQuestion([initialValues1]);
      // }
    } else {
      toast.error("Something Went Wrong");
    }
  };

  const PreviosCallbak = async (
    // Next k button pr answer save hoga
    answer,
    questiondataId,
    questiondataSubType,
    questiondataType,
    previousQuesitions
  ) => {
    var AddLastQuesionToInitalValue =
      previousQuesitions[previousQuesitions?.length - 1];

    setIntinalValues1(AddLastQuesionToInitalValue);
    const removeLastquestion = previousQuesitions?.pop();
    setPreviousQuestion([removeLastquestion]);
  };

  return (
    <div>
      <div id="main" class="main-section-login">
        <section class="all-star-gallery">
          <div className="section-heading plage-steps-dtl my-4">
            <h2 className="justify-content-between">
              {" "}
              {assignment == "awarenessCourses"
                ? t("awareness_courses")
                : t("assignment")}{" "}
            </h2>
          </div>
          <div className="bg-max-light">
            <div className="pr-dtl">
              {questions?.length == 0 ? (
                <center>{/* <h4>No Question In This Assignment</h4> */}</center>
              ) : (
                <div className="ques-type type-1">
                  <Row>
                    <p>
                      {t("questions")}: <b>{initialValues1?.questionNo}</b>/
                      {questionsforparent?.length}{" "}
                      <span>
                        {assignment == "awarenessCourses" ||
                        assignment == "awarenessCourses" ? (
                          ""
                        ) : (
                          <span>
                            {t("marks")}: <b>{initialValues1?.marks}</b>
                          </span>
                        )}
                      </span>{" "}
                    </p>
                  </Row>
                  {(initialValues1?.type == "writtenQuestion" ||
                    initialValues1?.type == "photoWithQuestion" ||
                    initialValues1?.type == "voiceOnly" ||
                    initialValues1?.type == "completeTheSentence" ||
                    initialValues1?.type == "completeTheWord" ||
                    initialValues1?.type == "videoWithQuestion") &&
                  initialValues1?.subtype == "subjective" ? (
                    <>
                      <SubjectiveQuestion
                        questiondata={initialValues1}
                        previousQuesitions={previousQuesitions}
                        questions={questionsforparent}
                        callback={DeleteIndexQuestion}
                        PreviosCallbak={PreviosCallbak}
                      />
                    </>
                  ) : (initialValues1?.type === "writtenQuestion" ||
                      initialValues1?.type == "sequenceMultipleChoose" ||
                      initialValues1?.type == "videoWithQuestion" ||
                      initialValues1?.type == "multipleChooseOnAnswer" ||
                      initialValues1?.type == "voiceOnly" ||
                      initialValues1?.type == "completeTheSentence" ||
                      initialValues1?.type == "completeTheWord" ||
                      initialValues1?.type == "match" ||
                      initialValues1?.type == "photoWithQuestion") &&
                    initialValues1?.subtype === "objective" ? (
                    <Type1
                      questiondata={initialValues1}
                      callback={DeleteIndexQuestion}
                      previousQuesitions={previousQuesitions}
                      questions={questionsforparent}
                      PreviosCallbak={PreviosCallbak}
                    />
                  ) : (initialValues1?.type == "writtenQuestion" ||
                      initialValues1?.type == "videoWithQuestion" ||
                      initialValues1?.type == "match" ||
                      initialValues1?.type == "multipleChooseOnAnswer" ||
                      initialValues1?.type ==
                        "multipleChooseMoreThanOneCorrectAnswer" ||
                      initialValues1?.type == "voiceOnly" ||
                      initialValues1?.type == "photoWithQuestion") &&
                    initialValues1?.subtype == "multipleSelect" ? (
                    <MultipleQuestion
                      questiondata={initialValues1}
                      previousQuesitions={previousQuesitions}
                      questions={questionsforparent}
                      callback={DeleteIndexQuestion}
                      PreviosCallbak={PreviosCallbak}
                    />
                  ) : (
                    ""
                  )}
                </div>
              )}
              {/* 
              <VideoQuestion />
              <AudioQuestion /> */}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Questions;
